import { forwardRef, useState, type InputHTMLAttributes, type ReactNode } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import './Input.css';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, iconLeft, iconRight, className = '', type, ...props }, ref) => {
    const [showPassword, setShowPassword] = useState(false);
    const isPassword = type === 'password';

    const inputType = isPassword ? (showPassword ? 'text' : 'password') : type;

    const classes = [
      'input-field',
      error ? 'input-field--error' : '',
      iconLeft ? 'input-field--has-left-icon' : '',
      isPassword || iconRight ? 'input-field--has-right-icon' : '',
      className,
    ].filter(Boolean).join(' ');

    return (
      <div className="input-group">
        {label && <label className="input-label">{label}</label>}
        <div className="input-wrapper">
          {iconLeft && <div className="input-icon-left">{iconLeft}</div>}
          <input ref={ref} type={inputType} className={classes} {...props} />
          
          {isPassword ? (
            <button
              type="button"
              className="input-icon-right"
              onClick={() => setShowPassword(!showPassword)}
              tabIndex={-1}
            >
              {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          ) : iconRight ? (
            <div className="input-icon-right" style={{ pointerEvents: 'none' }}>
              {iconRight}
            </div>
          ) : null}
        </div>
        {error && <span className="input-error-msg">{error}</span>}
      </div>
    );
  }
);

Input.displayName = 'Input';
